import { getAppData } from '../../lib/api/common'
import { getCareerPage } from '../../lib/api/career'

import Layout from '../../components/layout/Layout'
import SeoMaticHead from '../../components/common/SeoMaticHead'
import PageBuilder from '../../components/content/PageBuilder'
import PageHeader from '../../components/content/page/PageHeader'
import { revalidateSeconds } from "../../lib/helpers/revalidateSeconds";

export type CareerProps = {
	page: any
	app: any
}


export async function getStaticProps(context: any) {

	const app: any = await getAppData();
	const data: any = await getCareerPage(
		context.preview ? context.previewData?.token : undefined
	);

	return {
		props: {
			app: app ? app : null,
			page: data?.entry ? data.entry : null,
		},
		revalidate: revalidateSeconds()
	};
}


export default function Career(props: CareerProps) {

	const { page, app } = props

	// console.log('Career page props: ', props)

	return (
		<>
			<SeoMaticHead seo={page.seo} />
			<Layout
				appData={app}
				subHeader={[
					{
						id: page.id,
						title: page.title,
						uri: null
					}
				]}
			>
				<>

					<PageHeader page={page} />
					<PageBuilder contentBlocks={page.pageBuilder} />

				</>
			</Layout>
		</>
	)
}
